export const queryKeys = {
  // Projects
  projects: ['projects'] as const,
  project: (id: string) => ['projects', id] as const,

  // Inspirations
  inspirations: (projectId: string) => ['inspirations', projectId] as const,
  inspiration: (id: string) => ['inspirations', 'detail', id] as const,

  // Documents
  documents: (projectId: string, inspirationIds?: string[]) =>
    inspirationIds?.length
      ? ['documents', projectId, { inspirationIds }] as const
      : ['documents', projectId] as const,
  document: (id: string) => ['documents', 'detail', id] as const,
  documentInspirations: (documentId: string) => ['documents', documentId, 'inspirations'] as const,

  // Folders
  folders: (projectId: string) => ['folders', projectId] as const,

  // AI
  aiModels: ['ai', 'models'] as const,
  documentChatHistory: (documentId: string) => ['documents', documentId, 'chat', 'history'] as const,

  // User
  currentUser: ['user', 'current'] as const,

  // Creative DNA
  creativeDNA: (projectId: string) => ['creative-dna', projectId] as const,
  creativeDNADefaults: (projectId: string) => ['creative-dna', projectId, 'defaults'] as const,

  // Prompts
  prompts: (projectId: string) => ['prompts', projectId] as const,
  prompt: (id: string) => ['prompts', 'detail', id] as const,

  // Pricing
  pricing: ['pricing'] as const,
  pricePreview: (planSlug: string, couponCode: string | null, currency: string) =>
    ['pricing', 'preview', planSlug, couponCode, currency] as const,

  // Coupons
  couponValidation: (code: string) => ['coupon', 'validate', code] as const,

  // Project Stats
  projectStats: (projectId: string) => ['projects', projectId, 'stats'] as const,

  // Subscription
  subscription: ['subscription'] as const,
};
